module.exports = __webpack_public_path__ + "04_mole.e4c33005.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/04_mole.png
// module id = HslB
// module chunks = 0